<template>
    <div v-if="amount > 0">
        <div class="invoices-to-approve hidden-mobile">
          <heading colour="white" size="medium" no-margin>{{ amount }} Invoices Awaiting Approval</heading>
            <p>There are {{ amount }} invoices awaiting approval.</p>
            <ui-button colour="white" class="mt-4" :href="url">View Invoices</ui-button>
        </div>
        <div class="hidden-desktop dashboard-component-icon">
            <heading colour="white" size="medium">Invoices To Approve</heading>
            <a :href="url"><i class="fas fa-file"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                amount: 0
            }
        },
        props: ['url'],
        computed: {},
        watch: {},
        methods: {
            getInvoices() {
                var that = this;
                this.invoices = [];
                var params = {};
                params.filter = 'Awaiting Approval';
                params.mine = true;

                axios.get(appUrls.pis.index,{params:params})
                    .then(response => {
                        that.amount = response.data.meta.pagination.total;
                    });
            }
        },
        mounted() {
            this.getInvoices();
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-component-icon{
        background-color: $brand;
    }
    .invoices-to-approve {
        @include clearfix();
        background-color: $brand;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;

        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: $brand;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            &:hover{
                background-color: #dcefff;
            }
        }
    }
</style>
